import { useEffect, useState } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { normalizeQuickLinksData } from '../util/normalizeQuickLinksData';

const useQuickLinks = (componentId, experienceSSRData, slotName, mediaCollectionIndex) => {
  const {
    data: componentData,
    loading: componentLoading,
  } = useDataModel('quickLinks', {
    variables: {
      id: componentId
    },
    ssr: false,
    skip: !!slotName || (experienceSSRData && experienceSSRData?.length > 0),
    // TODO: remove this once @apollo/client has been updated within data-sources v27
    // or we are ready to use data-sources v28
    //
    // This is a temporary fix, due to the fact that the `useQuery` from apollo/client has a bug
    // that was preventing us from fetching the data normally.
    //
    // In production, we should still be passing the data from SSR from my-homepage.
    fetchPolicy: 'network-only'
  });
  const {
    data: slotData,
    loading: slotLoading
  } = useDataModel('slot', {
    fetchPolicy: 'cache-only',
    variables: { id: slotName },
    skip: !slotName || (experienceSSRData && experienceSSRData?.length > 0),
  });

  const [links, setLinks] = useState();
  const loading = slotName ? slotLoading : componentLoading;
  useEffect(() => {
    if (experienceSSRData !== undefined) {
      setLinks(experienceSSRData);
      return;
    }

    if (componentData) {
      const { linkList } = componentData?.component || {};
      if (linkList) {
        setLinks(linkList);
      }
    } else if (slotData?.slot) {
      const normalizedData = normalizeQuickLinksData({ slotData, mediaCollectionIndex });
      if (normalizedData?.linkList) {
        setLinks(normalizedData.linkList);
      }
    }
  }, [componentData, slotData, experienceSSRData, loading]);

  return { links, setLinks, loading };
};

export default useQuickLinks;